module.exports = __webpack_public_path__ + "img/Group 202.bd17fbcc.png";